/** CHECK-constrained pricing_type values (programs.pricing_type). */ export const PRICING_TYPE_OPTIONS = [
    {
        value: 'FFP',
        label: 'FFP'
    },
    {
        value: 'T_AND_M',
        label: 'T&M'
    },
    {
        value: 'CPFF',
        label: 'CPFF'
    },
    {
        value: 'CPIF',
        label: 'CPIF'
    },
    {
        value: 'CPAF',
        label: 'CPAF'
    },
    {
        value: 'FFP_LOE',
        label: 'FFP LOE'
    },
    {
        value: 'HYBRID',
        label: 'Hybrid'
    }
];
